module.exports = __webpack_public_path__ + "static/img-recipes.94ddcf2a.jpg";